<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12" md="12">
            <affix
              relative-element-selector="#jobseekercom-content"
              :offset="{ top: 70, bottom: 70 }"
              :class="!$vuetify.breakpoint.smAndDown ? 'container-affix-side' : 'top-zero'"
              :enabled="!$vuetify.breakpoint.smAndDown">
              <v-card
                rounded="lg"
                outlined>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="mb-1">
                        <h2 class="text-md-h6 font-weight-bold mb-3">
                          Location
                        </h2>
                      </div>
                      <v-autocomplete
                        v-model="paramdata.location"
                        :items="listlocation"
                        label="Location"
                        name="daerah"
                        prepend-inner-icon="mdi-map-marker"
                        multiple
                        @change="getJobseekerFilter">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="mb-1">
                        <h2 class="text-md-h6 font-weight-bold mb-3">
                          Specialization
                        </h2>
                      </div>
                      <v-autocomplete
                        v-model="paramdata.special"
                        :items="listspecial"
                        label="Specialization"
                        name="specialization"
                        prepend-inner-icon="mdi-account-details-outline"
                        multiple
                        @change="getJobseekerFilter">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="mb-1">
                        <h2 class="text-md-h6 font-weight-bold mb-3">
                          Monthly salary range
                        </h2>
                      </div>
                      <div>
                        <span class="green--text font-weight-bold">
                          {{ paramdata.gaji[0] * 1000000 | rupiahformat }} - {{ paramdata.gaji[1] * 1000000 | rupiahformat }}
                        </span>
                        <v-range-slider
                          hint="Monthly salary range"
                          persistent-hint
                          v-model="paramdata.gaji"
                          thumb-label
                          min="0"
                          step="5"
                          prepend-icon="mdi-cash-multiple"
                          @change="getJobseekerFilter">
                        </v-range-slider>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-btn
                        class="white--text"
                        :color="maincolor"
                        type="submit"
                        large
                        block
                        @click="getJobseekerFilter">
                        <v-icon left>search</v-icon> Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </affix>
          </v-col>
        </v-row>
      </v-col>
      <v-col id="jobseekercom-content" cols="12" md="8">
        <v-row v-if="datalist.length > 0">
          <v-col
            class="d-flex" style="flex-direction:column"
            cols="12"
            md="6"
            v-for="(acc, i) in datalist"
            :key="i">
            <comjobseeker :data="acc"></comjobseeker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <infinite-loading :identifier="infiniteId" @infinite="getJobseeker">
              <div slot="spinner">Loading...</div>
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Alertsp from '../../components/Alert.vue';
import Comjobseeker from '../../components/Comjobseeker.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';
import { Affix } from 'vue-affix';

export default {
  name: 'JobseekerCompany',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    listspecial: ['IT-Software', 'IT-Hardware', 'Hotel', 'Tourism', 'Public Relations', 'Banking', 'Accounting'],
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    listtype: ['full-time', 'part-time', 'interenship'],
    listjenisdata: [],
    listkecamatan: [],
    panduan: null,
    paramdata: {
      special: '',
      type: '',
      location: '',
      keyword: '',
      gaji: [1, 9],
      limit: 20,
      offset: 0,
    },
    filter: {
      type: '',
      special: '',
      location: '',
      gaji: [3, 7],
      jenisdata: '',
      year: [],
      olahraga: '',
      tingkat: '',
      kelamin: '',
      kecamatan: '',
      kelurahan: '',
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    if (this.$route.query.category && this.$route.query.category !== '') {
      this.paramdata.special = this.$route.query.category;
    }
    if (this.$route.query.keyword && this.$route.query.keyword !== '') {
      this.paramdata.keyword = this.$route.query.keyword;
    }
    if (this.$route.query.location && this.$route.query.location !== '') {
      this.paramdata.location = this.$route.query.location;
    }
    // this.$nextTick(function() {
    //   this.getJobseeker(false);
    // });
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return priceFromat(0, 'Rp');
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    // '$route.query.category'(val) {
    //   if (val) {
    //     this.paramdata.special = val;
    //     this.getJobseeker(false);
    //   }
    // },
  },
  methods: {
    getJobseekerFilter() {
      this.paramdata.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getJobseeker($state) {
      // console.log(this.paramdata);
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/company/search-js',
            {
              params: this.paramdata,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramdata.offset += this.paramdata.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.js_picture;
                    element.urlresume = this.api + '/upload/resume/' + element.js_resume;
                    this.datalist.push(element);
                  });
                  // this.datalist.push(...resdata.data);
                  if (this.datalist.length < this.paramdata.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    Affix,
    Comjobseeker,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .container-affix-side{
    width: 100%;
    max-width: 370px;
  }
  .top-zero{
    top: initial !important;
  }
</style>
